import isNil from 'lodash/isNil';
import { useQueryStates } from 'nuqs';
import { SEARCH_PARAMS } from '@/routes/search-params';
import { ALL_PORTFOLIOS_ITEM } from '@/sections/StatusQuoAnalysis/NavigationSelectors/Hooks/usePortfolioSelector';
import { useStatusQuoSelectionStorage } from '@/sections/StatusQuoAnalysis/useStatusQuoSelectionStorage';

export const RedirectToStatusQuoFirstPortfolio = () => {
  const [queryParams, setQueryParams] = useQueryStates(SEARCH_PARAMS.statusQuoAnalysis.portfolio);

  const { portfolioIds: storedPortfolioIds } = useStatusQuoSelectionStorage();

  if (queryParams.portfolioIds?.length === 1 && queryParams.portfolioIds[0] === ALL_PORTFOLIOS_ITEM().value) {
    return null;
  }

  if (
    !isNil(storedPortfolioIds) &&
    storedPortfolioIds.length > 0 &&
    (isNil(queryParams.portfolioIds) || queryParams.portfolioIds.length === 0)
  ) {
    void setQueryParams({ portfolioIds: storedPortfolioIds });
    return null;
  }

  if (isNil(queryParams.portfolioIds) || queryParams.portfolioIds.length === 0) {
    void setQueryParams({ portfolioIds: [ALL_PORTFOLIOS_ITEM().value] });
    return null;
  }

  return null;
};
